<div class="string-answer">
  <app-icon [size]="'20'" [glyph]="'pencil'"></app-icon>
</div>
